import { render, staticRenderFns } from "./LookMoney.vue?vue&type=template&id=048a7b44&scoped=true"
import script from "./LookMoney.vue?vue&type=script&lang=js"
export * from "./LookMoney.vue?vue&type=script&lang=js"
import style0 from "./LookMoney.vue?vue&type=style&index=0&id=048a7b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a7b44",
  null
  
)

export default component.exports